import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { PatientInfoPanel } from 'src/components/complex';

import { lang, permissions, withRouter } from 'src/helpers';

import model from './model';
import { BASE_ICONS } from 'src/components/svg';
import LANG_CONST from 'src/helpers/lang/const';
import { MCButton, Spinner } from 'src/components/basic';
import AddTreatment from 'src/components/treatments/Create';

class CreateTreatment extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    if (this.props.router?.params.patientId) {
      model.loadPatient(Number(this.props.router.params.patientId), (error, patient) => {
        if (error) {
          this.back();
        } else {
          this.setState({ patient });
        }
      });
    }
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  renderPatient = () => {
    const { patient } = this.state;

    return (
      <div className={'mc-container-content__body-right'}>
        <PatientInfoPanel
          patient={{ ...patient }}
          viewProfile={() =>
            this.navigate(permissions.PAGES.PATIENTS_DETAIL_PAGE.match(patient.id))
          }
          // model={filesModel}
          template={2}
          hideHeader={true}
        />
      </div>
    );
  };

  render() {
    const { patient } = this.state;

    return (
      <div className={'mc-container-content mc-treatment-detail'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <MCButton
            onClick={this.back}
            iconname={BASE_ICONS.BACK_ARROW}
            circle
            primary
            dark
            width={40}
          />
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.add_treatment)}</span>
        </div>
        {!patient ? (
          <div className={'mc-flex'}>
            <Spinner />
          </div>
        ) : (
          <div className={'mc-container-content__body horizontal'}>
            <div className={'mc-grow mc-p25 mc-flex-20-col'} style={{ overflow: 'auto' }}>
              <AddTreatment
                isPopup={false}
                partnerId={patient.id}
                afterSave={(error, data, success) => {
                  if (success) this.back();
                }}
              />
            </div>
            {this.renderPatient()}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(CreateTreatment);
